import { render } from "./Encomendas.vue?vue&type=template&id=1e1cf856&scoped=true"
import script from "./Encomendas.vue?vue&type=script&lang=js"
export * from "./Encomendas.vue?vue&type=script&lang=js"

import "./Encomendas.vue?vue&type=style&index=0&id=1e1cf856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1cf856"]])

export default __exports__